export default class CollapseEnum {
    static COLLAPSE_TRIGGER = '[data-trigger="wpet-collapse-toggle"]'
    static COLLAPSE_ELEMENT = '[data-element="wpet-collapse"]'
    static COLLAPSE_TRIGGER_OPEN_CLASS = 'open'
}
